import React from "react";
import { Lock, ShieldCheck } from "lucide-react";

export const PaymentBadges = ({ className = "" }) => (
  <div
    data-testid="payment-badges"
    className={`flex flex-wrap items-center gap-x-4 gap-y-2 text-xs ${className}`}
    style={{ color: "var(--ink-soft)" }}
  >
    <span className="inline-flex items-center gap-1.5">
      <Lock size={13} color="var(--sun-orange)" strokeWidth={2} />
      Secure checkout by <strong style={{ color: "var(--ink)" }}>Paystack</strong>
    </span>
    <span className="inline-flex items-center gap-2 font-mono uppercase tracking-wide" style={{ fontSize: "0.65rem" }}>
      <span className="pay-chip">Visa</span>
      <span className="pay-chip">Mastercard</span>
      <span className="pay-chip">Verve</span>
    </span>
    <span className="inline-flex items-center gap-1.5">
      <ShieldCheck size={13} color="var(--sun-orange)" strokeWidth={2} />
      WhatsApp support 7 days a week
    </span>
  </div>
);

export default PaymentBadges;
